import { createClient } from "./client.ts";
import type { ApiClientOptions, ClientOf, ConsolePaths } from "./client.ts";

export type ConsoleClient = ClientOf<ConsolePaths>;

export const createConsoleClient = (options: ApiClientOptions): ConsoleClient =>
  createClient<ConsolePaths>(options);
